import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import ImageLoader from 'react-imageloader';
import { FoldingCube } from 'better-react-spinkit';
import MapStyles from './mapStyles.json';

const mapStylesString = MapStyles.map(definition => {
    let feature = `feature:${definition.featureType}`;
    let element = `element:${definition.elementType}`;
    let styles = definition.stylers.map(style => {
        let key = Object.keys(style)[0];
        let value = style[key];

        if (typeof value === 'string') {
            value = value.replace('#', '0x');
        }

        return key + ':' + value;
    });

    return [feature, element, ...styles].join('|');
}).reduce((prev, curr) => {
    return `${prev}&style=${curr}`;
}, '');

class StaticMap extends React.Component {

    size = { width: 300, height: 300 };

    getStaticMapUrl() {
        var self = this;

        const rootUrl = '//maps.googleapis.com/maps/api/staticmap';
        const apiKey = 'AIzaSyDx8Pgi1sbSo7cbTBQr2I6SysbKLwwM2Iw';
        const latitude = self.props.point.location.lat;
        const longitude = self.props.point.location.lng;
        const zoom = 13;
        const size = self.size;
        const format = 'png';
        const mapType = 'terrain';

        const { width, height } = size;
        const markers = `color:0xFF0000|${latitude},${longitude}`;

        return `${rootUrl}?center=${latitude},${longitude}&zoom=${zoom}&scale=1&size=${width}x${height}&format=${format}&key=${apiKey}&markers=${markers}${mapStylesString}`;
    }

    render () {
        var self = this;

        return (
            <ImageLoader src={ self.getStaticMapUrl() } className="gmap-point-container" preloader={ (preloader) => <FoldingCube color="#ccc" size={ 40 } /> }>
                <span className="text-muted-inverse"><i className="fa fa-warning" style={ { color: '#aaff00' } }></i> Uh oh. Google Maps doesn't seem to be awake yet. Let's give them the benefit of the doubt and try again later.</span>
            </ImageLoader>
        );
    }
};

export default StaticMap;


// WEBPACK FOOTER //
// ./src/app/components/googleMap/staticMap.jsx